import FoldersRequest from '../requests/folders-request'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import Folder from '../entities/folder'
import axios from '@/app/axios'
import Responses from '@/app/utils/responses'

class FoldersService {
  public async findAllAsync(request: FoldersRequest) {
    const res = await axios.post<PaginationResponse<Folder>>(
      'folder/list',
      request
    )
    return Responses.pagedList(res)
  }

  public async findGrouped(search: string, includeArchived: boolean) {
    const params = {
      search,
      includeArchived,
    }
    const res = await axios.post<Folder[]>('folder/list-grouped', params)
    return Responses.list(res)
  }

  public async loadAllNamesAsync() {
    const res = await axios.get<string[]>('folder/list-names')
    return Responses.list(res)
  }

  public async createAsync(folder: Folder) {
    const res = await axios.post<Folder>(`folder/create`, folder)
    return Responses.obj(res)
  }

  public async updateAsync(folder: Folder) {
    const res = await axios.put<Folder>('folder/update', folder)
    return Responses.obj(res)
  }

  public async deleteAsync(folder: Folder) {
    const res = await axios.post<Folder>(`folder/${folder.id}/delete`)
  }
}

export default new FoldersService()
